function renderNestedObjectListFieldContentTemplate({
  indent,
  itemIndexVar,
  pathString,
  titlePathSuffix,
  singularLabel
}: {
  indent: string
  itemIndexVar: string
  pathString: string
  titlePathSuffix: string
  singularLabel: string
}): string {
  return `\n${indent}  renderTitle={(${itemIndexVar}) =>
${indent}    String(form.watch(\`${pathString}.\${${itemIndexVar}}${titlePathSuffix}\` as never) || \`${singularLabel} \${${itemIndexVar} + 1}\`)
${indent}  }`
}

function renderNestedObjectListFieldNestedObjectListFieldTemplate({
  indent,
  pathExpression,
  stringify,
  stringifySerializedValue,
  defaultItem,
  hideLabelProp,
  descriptionProp,
  maxItemsProp,
  validatePathsProp,
  renderTitleProp,
  itemIndexVar,
  nestedFieldsJsx
}: {
  indent: string
  pathExpression: string
  stringify: string
  stringifySerializedValue: string
  defaultItem: string
  hideLabelProp: string
  descriptionProp: string
  maxItemsProp: string
  validatePathsProp: string
  renderTitleProp: string
  itemIndexVar: string
  nestedFieldsJsx: string
}): string {
  return `${indent}<NestedObjectListField
${indent}  name={${pathExpression}}
${indent}  label={${stringify}}
${indent}  singularLabel={${stringifySerializedValue}}
${indent}  defaultValue={${defaultItem}}
${indent}  disabled={isPending}${hideLabelProp}${descriptionProp}${maxItemsProp}${validatePathsProp}${renderTitleProp}
${indent}>
${indent}  {(${itemIndexVar}) => (
${indent}    <>
${nestedFieldsJsx}
${indent}    </>
${indent}  )}
${indent}</NestedObjectListField>`
}

export function renderNestedObjectListFieldRenderer(
  request:
    | {
        kind: 'renderNestedObjectListFieldContentTemplate'
        props: {
          indent: string
          itemIndexVar: string
          pathString: string
          titlePathSuffix: string
          singularLabel: string
        }
      }
    | {
        kind: 'renderNestedObjectListFieldNestedObjectListFieldTemplate'
        props: {
          indent: string
          pathExpression: string
          stringify: string
          stringifySerializedValue: string
          defaultItem: string
          hideLabelProp: string
          descriptionProp: string
          maxItemsProp: string
          validatePathsProp: string
          renderTitleProp: string
          itemIndexVar: string
          nestedFieldsJsx: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderNestedObjectListFieldContentTemplate':
      return renderNestedObjectListFieldContentTemplate(request.props)
    case 'renderNestedObjectListFieldNestedObjectListFieldTemplate':
      return renderNestedObjectListFieldNestedObjectListFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
